module.exports = __webpack_public_path__ + "static/img/h6.6354c7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hor/h6.jpg
// module id = gPEC
// module chunks = 1